import React from 'react';
import {formatCoordinates, formatElevation} from '../../utils/formatters';
import useGetSyncPromise from '../../utils/react/useGetSyncPromise';
import fetchElevation from '../../utils/gaia/fetchElevation';
import fetchUser from '../../utils/gaia/fetchUser';
import Typography from '@material-ui/core/Typography';

export default function WaypointStats({waypoint, interaction}: {
    interaction: MapInteraction;
    waypoint: Waypoint;
}) {

    const getSyncPromise = useGetSyncPromise();
    const [user] = getSyncPromise(fetchUser());

    const isDragging = (
        interaction.type === 'movingWaypoint' &&
        interaction.subtype === 'dragging' &&
        interaction.pointLocalId === waypoint.properties.pointLocalId
    );

    const [elevation, elevationError] = isDragging ?
        [undefined, undefined] :
        getSyncPromise(fetchElevation(waypoint.geometry, waypoint.properties.elevation));

    return <div style={{flex: 1}}>
        <Typography component='div' color="inherit" variant="body2">
            {formatCoordinates(waypoint.geometry.coordinates)}
        </Typography>

        <Typography component='div' color="inherit" variant="body2">
            <strong>Elevation: </strong>
            {elevationError ? 'Error' :
                elevation !== undefined ?
                    formatElevation(elevation.coordinates[2], user) :
                    '...'
            }
        </Typography>
    </div>;
}
